// Reposition form success message
export default document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form')

  if (!form) {
    return
  }

  form.addEventListener('freeform-render-success', (event) => {
    event.preventDefault()

    const { freeform } = event
    const success = document.createElement('div')
    success.classList.add(freeform.options.successClassBanner)
    success.appendChild(
      document.createTextNode(freeform.options.successBannerMessage)
    )

    form.appendChild(success)
  })
})
